import { createSlot } from '@ayocore/platform/client/extensions/createSlot';

/**
 * Слоты расширения для страницы профиля пользователя.
 *
 * Клиентские модули (например, telegram) могут добавлять карточки
 * в профиль пользователя без изменения кода identity-модуля.
 *
 * Регистрация — в bootstrap.ts клиентского модуля:
 * @example
 * AuthenticationPageExtensions.profileCards.register(() => <MyCard />);
 */
export const AuthenticationPageExtensions = {
  /** Дополнительные карточки в профиле пользователя */
  profileCards: createSlot<Record<string, never>>(),
};
